import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/inter'
import '@fontsource-variable/azeret-mono'
import 'bootstrap/dist/css/bootstrap-reboot.min.css'
import './design-system/tokens.css'
import './design-system/foundation.css'
import { AppErrorBoundary } from './app/AppErrorBoundary'
import { RootApp } from './app/RootApp'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary><Suspense fallback={<main id="main-content"><p role="status">Carregando…</p></main>}><RootApp /></Suspense></AppErrorBoundary>
  </StrictMode>,
)
